// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".proList .el-row[data-v-5bdd7452]{margin-bottom:20px}.proList .el-row[data-v-5bdd7452]:last-child{margin-bottom:0}.proList .img-con[data-v-5bdd7452]{width:100%;height:132px}.proList .img-con img[data-v-5bdd7452]{width:100%;height:100%;display:block}.proList .proInfo[data-v-5bdd7452]{background-color:#fff;padding:10px 8px}.proList .proInfo .infoOne[data-v-5bdd7452]{overflow:hidden}", ""]);
// Exports
module.exports = exports;
